import React from 'react';
import { VictoryAxis, VictoryLabel } from 'victory';

const XAxis = (
  tickValues,
  tickFormat,
  fill: string,
  dy: number,
  horizontalTickCount: number,
) => <VictoryAxis
    crossAxis={false}
    tickCount={horizontalTickCount}
    {...{ tickValues, tickFormat }}
    fixLabelOverlap
    style={{
      axis: { stroke: 'none' },
      tickLabels: { fontSize: 14, lineHeight: 11 },
    }}
    tickLabelComponent={<VictoryLabel
      {...{ dy }}
      dx={-20}
      style={{
        fill,
        fontSize: 14,
        lineHeight: 11,
        strokeWidth: 0,
        fontFamily: 'Poppins_400Regular',
        textAnchor: 'center',
      }}
    />}
  />;

export default XAxis;
